// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PROFILE_SET_LOADING_PASSWORD,
} from './constants';

export function setLoadingPassword() {
  return {
    type: PROFILE_SET_LOADING_PASSWORD,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_SET_LOADING_PASSWORD:
      return {
        ...state,
        changePasswordStatus:null,
        loadingChangePassword:true,
        updatingSuccess:false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/setLoadingPassword.js